import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ProgramMembershipsBackend } from '@libs/src/program-memberships/program-memberships.backend';

import { ProgramMembership } from '@libs/src/models/program-membership.model';

@Injectable()
export class ProgramMembershipResolver implements Resolve<any> {
  constructor(private programMembershipsBackend: ProgramMembershipsBackend) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
    const token = route.queryParamMap.get('programToken');
    if (!token) {
      return null;
    }
    return this.programMembershipsBackend.v3
      .getProgramMembershipToken(token)
      .pipe(
        map(
          ({ programMembership }: { programMembership: ProgramMembership }) =>
            programMembership,
        ),
        catchError(() => EMPTY),
      );
  }
}
